import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { handleErrorResponse } from "../../apis";

export const removeBox = createAsyncThunk('removeBox', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}bulk-inventory-movement/gatepass/box/remove`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const reopenGatepass = createAsyncThunk('reopenGatepass', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}bulk-inventory-movement/gatepass/reopen`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});